import { configure, addDecorator } from '@storybook/react'
import { setIntlConfig, withIntl } from 'storybook-addon-intl'
import withMui from './withMui'
import withStore from './withStore'
import withRouter from './withRouter'
import enMessages from '../src/messages/en.json'
import deMessages from '../src/messages/de.json'
import enWebonlyMessages from '../src/messages/webonly/en.json'
import deWebonlyMessages from '../src/messages/webonly/de.json'

import '../src/fonts.css'

const messages = {
  en: {...enMessages, ...enWebonlyMessages},
  de: {...deMessages, ...deWebonlyMessages},
}

const getMessages = (locale) => messages[locale]

setIntlConfig({
  locales: ['en', 'de'],
  defaultLocale: 'en',
  getMessages
})

addDecorator(withRouter)
addDecorator(withStore)
addDecorator(withMui)
addDecorator(withIntl)

function requireAll(requireContext) {
  return requireContext.keys().map(requireContext)
}

function loadStories() {
  requireAll(require.context('../src/stories', true))
}

configure(loadStories, module);
